
document.addEventListener('DOMContentLoaded', () => {
    const blurBackground = document.createElement('div');
    blurBackground.classList.add('blur');
    document.body.appendChild(blurBackground);
    let equipmentOrderForm = null;
    let bookletForm = null;

    // Находим все кнопки, которые должны открывать попапы
    const openPopupButtons = document.querySelectorAll('[id^="openPopup"]');

    // Для каждой кнопки добавляем слушатель кликов
    openPopupButtons.forEach(button => {
        button.addEventListener('click', () => {
            const popupId = button.getAttribute('data-popup');
            var elementId = button.getAttribute('data-product'); // Получаем id продукта
            const popup = document.querySelector(`.js-popup[data-popup="${popupId}"]`);
            if (popup) {
                openPopup(blurBackground, popup, elementId);
            }
        });
    });

    // Функция для открытия попапа
    const openPopup = (blurBackground, popup, elementId) => {
        popup.setAttribute('aria-hidden', 'false');
        blurBackground.style.opacity = '1';
        blurBackground.style.visibility = 'visible';

        setTimeout(() => {
            popup.classList.add('show-popup');
            popup.style.top = "50%";
            // Инициализация формы здесь, если это попап с формой спецтехники "Узнать стоимость"
            if(popup.getAttribute('data-popup') === 'popup-get-price-special-equipment') {
                // Устанавливаем id спецтехники перед инициализацией формы
                const app = new BX.FormPopupGetPriceSpecialEquipment('#popup_get_price_special_equipment', elementId);
                app.start();
            }
            // Инициализация формы заказа оборудования и обновление выбранного товара
            if(popup.getAttribute('data-popup') === 'popup-get-price-equipment') {
                if (!equipmentOrderForm) {
                    equipmentOrderForm = new BX.FormPopupGetPriceEquipment('#popup_get_price_equipment', elementId);
                    equipmentOrderForm.start();
                } else {
                    equipmentOrderForm.setProductId(elementId);
                }
            }
            // Инициализация формы здесь, если это попап с формой заявки техники в лизинг
            if(popup.getAttribute('data-popup') === 'popup-lizing-special-equipment') {
                // Устанавливаем id спецтехники перед инициализацией формы
                const app = new BX.FormPopupLizingSpecialEquipment('#popup_lizing_special_equipment', elementId);
                app.start();
            }
            // Инициализация формы здесь, если это попап с формой заявки на услугу "Узнать стоимость"
            if(popup.getAttribute('data-popup') === 'popup-get-price-services') {
                // Устанавливаем id услуги перед инициализацией формы
                const app = new BX.FormPopupGetPriceServices('#popup_get_price_services', elementId);
                app.start();
            }
            // Инициализация формы здесь, если это попап с формой заявки запчасти в лизинг
            if(popup.getAttribute('data-popup') === 'popup-get-price-parts') {
                // Устанавливаем id запчасти перед инициализацией формы
                const app = new BX.FormPopupGetPriceParts('#popup_get_price_parts', elementId);
                app.start();
            }
            // Инициализация формы здесь, если это попап с формой заявки на получение буклета
            if(popup.getAttribute('data-popup') === 'buklet') {
                // Устанавливаем id спецтехники перед инициализацией формы
                if (!bookletForm) {
                    bookletForm = new BX.FormBuklet('#buklet', elementId);
                    bookletForm.start();
                } else {
                    bookletForm.setProductId(elementId);
                }
            }
        }, 100);
    };

    // Функция для закрытия попапа
    const closePopup = (blurBackground, popup) => {
        popup.setAttribute('aria-hidden', 'true');
        blurBackground.style.opacity = '0';
        blurBackground.style.visibility = 'hidden';

        popup.classList.remove('show-popup');
        popup.style.top = "-100%";
    };

    // Находим все попапы и для каждого попапа находим кнопку закрытия внутри
    const popups = document.querySelectorAll('.js-popup');
    popups.forEach(popup => {
        const closePopupButton = popup.querySelector('.popup__close-button');
        if (closePopupButton) {
            closePopupButton.addEventListener('click', () => { closePopup(blurBackground, popup) });
        }
        blurBackground.addEventListener('click', () => { closePopup(blurBackground, popup) });
    });
});
